<template>
  <div class="crud_form_wrapper">
    <div class="form_title_wrapper">
      <h4>{{ $t("MESSAGES.showBanner") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #405950">
        <i
          :class="$i18n.locale === 'en' ? 'fas fa-forward' : 'fas fa-backward'"
        ></i>
      </v-btn>
    </div>

    <div class="single_step_form_content_wrapper">
      <form>
        <div class="row">
          <div v-if="data.image.path" class="col-12">
            <div class="preview-container text-center my-3">
              <h6 style="color: #405950">
                {{ $t("MESSAGES.Banner images") }}
              </h6>
              <video
                v-if="isVideoFile(data.image.path)"
                :src="data.image.path"
                controls
                loop
                muted
              />
              <img v-else :src="data.image.path" :alt="$t('MESSAGES.Banner images')" />
            </div>
          </div>

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameAr')"
            v-model.trim="data.nameAr"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameEn')"
            v-model.trim="data.nameEn"
            disabled
          />

          <base-picker-input
            col="6"
            type="date"
            :placeholder="$t('PLACEHOLDERS.start_date')"
            v-model.trim="data.publish_start_date"
            disabled
          />

          <base-picker-input
            col="6"
            type="date"
            :placeholder="$t('PLACEHOLDERS.end_date')"
            v-model.trim="data.publish_end_date"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('MESSAGES.bannerRelatedType')"
            :value="relatedTypeLabel"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="relatedItemPlaceholder"
            :value="relatedItemLabel"
            disabled
          />

          <div class="input_wrapper switch_wrapper my-5 col-lg-6">
            <v-switch
              color="green"
              :label="
                data.is_fixed
                  ? $t('MESSAGES.bannerIsFixed')
                  : $t('MESSAGES.bannerNotFixed')
              "
              v-model="data.is_fixed"
              hide-details
              disabled
            />
          </div>

          <div class="input_wrapper switch_wrapper my-5 col-lg-6">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
              disabled
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
const VIDEO_EXTENSIONS = [
  "mp4",
  "mov",
  "avi",
  "wmv",
  "flv",
  "mkv",
  "webm",
  "m4v",
];

export default {
  name: "ShowAds",

  data() {
    return {
      data: {
        image: {
          path: null,
        },
        nameAr: null,
        nameEn: null,
        active: true,
        is_fixed: false,
        publish_start_date: null,
        publish_end_date: null,
        related_type: null,
        related_id: null,
      },
      festivalsList: [],
      offersList: [],
    };
  },

  computed: {
    relatedTypes() {
      return [
        { id: "festival", name: this.$t("MESSAGES.festival") },
        { id: "offer", name: this.$t("MESSAGES.offer") },
      ];
    },
    relatedTypeLabel() {
      if (!this.data.related_type) return "-";

      return (
        this.relatedTypes.find((type) => type.id === this.data.related_type)
          ?.name || this.data.related_type
      );
    },
    relatedItemPlaceholder() {
      if (this.data.related_type === "festival") {
        return this.$t("MESSAGES.selectFestival");
      }

      if (this.data.related_type === "offer") {
        return this.$t("MESSAGES.selectOffer");
      }

      return this.$t("MESSAGES.bannerRelatedType");
    },
    relatedItemLabel() {
      if (!this.data.related_type || this.data.related_id == null) return "-";

      const options =
        this.data.related_type === "festival"
          ? this.festivalsList
          : this.offersList;

      const match = options.find(
        (item) => Number(item.id) === Number(this.data.related_id)
      );

      return match?.name || `#${this.data.related_id}`;
    },
  },

  methods: {
    isVideoFile(path) {
      if (!path) return false;

      const extension = String(path).split(".").pop()?.toLowerCase();
      return VIDEO_EXTENSIONS.includes(extension);
    },

    mapRelatedOptions(items) {
      return (items || []).map((item) => ({
        ...item,
        name: item.name || item.name_ar || item.name_en,
      }));
    },

    async getFestivalsList() {
      try {
        const res = await this.$axios({
          method: "GET",
          url: "festivals?page=0&limit=0",
        });
        this.festivalsList = this.mapRelatedOptions(res.data.data.data);
      } catch (error) {
        console.log(error.response?.data?.message);
      }
    },

    async getOffersList() {
      try {
        const res = await this.$axios({
          method: "GET",
          url: "offers?page=0&limit=0",
        });
        this.offersList = this.mapRelatedOptions(res.data.data.data);
      } catch (error) {
        console.log(error.response?.data?.message);
      }
    },

    async getAdsData() {
      try {
        await Promise.all([this.getFestivalsList(), this.getOffersList()]);

        const res = await this.$axios({
          method: "GET",
          url: `banners/${this.$route.params.id}`,
        });
        const banner = res.data.data.Banner;

        this.data.image.path = banner.image;
        this.data.nameAr = banner.title_ar || banner.title;
        this.data.nameEn = banner.title_en;
        this.data.publish_start_date = banner.start_date;
        this.data.publish_end_date = banner.end_date;
        this.data.active = !!banner.is_active;
        this.data.is_fixed = !!banner.is_fixed;
        this.data.related_type = banner.related_type || null;
        this.data.related_id = banner.related_id ?? null;
      } catch (error) {
        console.log(error.response?.data?.message);
      }
    },
  },

  created() {
    this.getAdsData();
  },
};
</script>

<style>
.preview-container img,
.preview-container video {
  max-width: 100%;
  max-height: 200px;
  border: 1px solid #ccc;
  border-radius: 20px;
}
</style>
